import { DynamicShiftStatus } from '@bemlo/enums'

import { Color } from '../../constants'

export const STATUS_COLOR_MAP: Record<
  DynamicShiftStatus,
  {
    text: Color
    borderOuter: Color
    borderInner: Color
    background: Color
  }
> = {
  [DynamicShiftStatus.APPLICATION_NOT_CHOSEN]: {
    text: Color.DARK_RED,
    borderOuter: Color.DARK_RED,
    borderInner: Color.TRANSPARENT_RED,
    background: Color.LIGHTER_RED,
  },
  [DynamicShiftStatus.AVAILABLE]: {
    text: Color.BLUE,
    borderOuter: Color.BLUE,
    borderInner: Color.TRANSPARENT_BLUE,
    background: Color.LIGHTER_BLUE,
  },
  [DynamicShiftStatus.BOOKED]: {
    text: Color.DARKER_GREEN,
    borderOuter: Color.DARK_GREEN,
    borderInner: Color.LIGHTER_BLUE,
    background: Color.TRANSPARENT_GREEN,
  },
  [DynamicShiftStatus.CANCELED]: {
    text: Color.DARK_GREY,
    borderOuter: Color.DARK_GREY,
    borderInner: Color.MEDIUM_GREY,
    background: Color.LIGHT_GREY,
  },
  [DynamicShiftStatus.APPLIED]: {
    text: Color.DARK_YELLOW,
    borderOuter: Color.DARK_YELLOW,
    borderInner: Color.YELLOW,
    background: Color.LIGHT_YELLOW,
  },
  [DynamicShiftStatus.REJECTED]: {
    text: Color.DARK_RED,
    borderOuter: Color.DARK_RED,
    borderInner: Color.TRANSPARENT_RED,
    background: Color.LIGHTER_RED,
  },
  [DynamicShiftStatus.OCCUPIED]: {
    text: Color.DARK_GREY,
    borderOuter: Color.DARK_GREY,
    borderInner: Color.MEDIUM_GREY,
    background: Color.LIGHT_GREY,
  },
  [DynamicShiftStatus.WITHDRAWN]: {
    text: Color.GOLDEN_ROD,
    borderOuter: Color.GOLDEN_ROD,
    borderInner: Color.GOLDEN_ROD,
    background: Color.LIGHT_YELLOW,
  },
  [DynamicShiftStatus.SUGGESTED]: {
    text: Color.DARK_YELLOW,
    borderOuter: Color.GOLDEN_ROD,
    borderInner: Color.YELLOW,
    background: Color.YELLOW,
  },
  [DynamicShiftStatus.ACCEPTED]: {
    text: Color.CHARCOAL,
    borderOuter: Color.GOLDEN_ROD,
    borderInner: Color.YELLOW,
    background: Color.YELLOW,
  },
}

export const useShiftCardColors = (
  status: DynamicShiftStatus,
  isUrgent: boolean,
) => {
  const statusColor = STATUS_COLOR_MAP[status]

  return {
    ...statusColor,
    statusBorder: isUrgent ? Color.RED : statusColor.text,
  }
}

export type ShiftCardColor = ReturnType<typeof useShiftCardColors>
